// Labels and error wording of Review Dokumen (/review-dokumen). The document
// types mirror apps/api/src/modules/docreview/checklist.ts (DOC_TYPES and
// each type's label): change both together when the types change.
import * as API from "../api";
import type { DocReviewType, ReviewFinding, ReviewStatus } from "../api";

export const DOC_TYPE_LABEL: Record<DocReviewType, string> = {
  kak: "KAK / Spesifikasi Teknis",
  hps: "HPS",
  rab: "RAB",
  dokumen_pemilihan: "Dokumen Pemilihan",
  rancangan_kontrak: "Rancangan Kontrak",
  surat: "Surat / Berita Acara",
  dokumen_penawaran: "Dokumen Penawaran",
  lainnya: "Lainnya",
};

/** The select order, Lainnya last. */
export const DOC_TYPES = Object.keys(DOC_TYPE_LABEL) as DocReviewType[];

export const STATUS_LABEL: Record<ReviewStatus, string> = { siap: "Siap", perlu_perbaikan: "Perlu perbaikan", belum_lengkap: "Belum lengkap" };
export const STATUS_TONE: Record<ReviewStatus, "success" | "warning" | "danger"> = { siap: "success", perlu_perbaikan: "warning", belum_lengkap: "danger" };

/** The kategori in the order the result lists them. */
export const CATEGORIES: { id: ReviewFinding["kategori"]; label: string }[] = [
  { id: "kelengkapan", label: "Kelengkapan" },
  { id: "konsistensi", label: "Konsistensi" },
  { id: "aturan", label: "Kesesuaian aturan" },
  { id: "lainnya", label: "Lainnya" },
];
export const LEVEL_LABEL: Record<ReviewFinding["tingkat"], string> = { tinggi: "Tinggi", sedang: "Sedang", rendah: "Rendah" };
export const LEVEL_TONE: Record<ReviewFinding["tingkat"], "danger" | "warning" | "neutral"> = { tinggi: "danger", sedang: "warning", rendah: "neutral" };
export const LEVEL_ORDER: ReviewFinding["tingkat"][] = ["tinggi", "sedang", "rendah"];

/** Word, PDF, Excel or plain text, at most 10 MB (as the API checks). */
export const UPLOAD_ACCEPT = ".docx,.pdf,.xlsx,.txt";
export const UPLOAD_MAX_BYTES = 10 * 1024 * 1024;
export const MIN_TEXT = 40;
export const MAX_TEXT = 200_000;
export const MAX_INSTRUCTIONS = 2_000;

/** Why a picked file cannot be reviewed, or null. */
export function uploadProblem(file: File): string | null {
  if (!/\.(docx|pdf|xlsx|txt)$/i.test(file.name)) return "Unggah file Word (.docx), PDF, Excel (.xlsx), atau teks (.txt).";
  if (file.size > UPLOAD_MAX_BYTES) return "Ukuran file maksimal 10 MB.";
  if (file.size === 0) return "File kosong. Pilih file yang berisi teks.";
  return null;
}

const ERRORS: Record<string, string> = {
  no_input: "Unggah file atau tempel teks dokumen terlebih dahulu.",
  unsupported_file: "Unggah file Word (.docx), PDF, Excel (.xlsx), atau teks (.txt).",
  file_too_large: "Ukuran file maksimal 10 MB.",
  empty_text: "Teks dokumen terlalu pendek untuk direviu.",
  feature_disabled: "Review Dokumen tidak tersedia untuk peran Anda.",
};

/** One clear sentence per error code; the API's own text otherwise. */
export function reviewErrorMessage(err: unknown): string {
  const code = err instanceof API.ApiError ? err.body?.code : null;
  if (typeof code === "string" && ERRORS[code]) return ERRORS[code]!;
  return API.errorMessage(err);
}

export function reviewErrorTitle(err: unknown): string {
  if (err instanceof API.ApiError && err.status === 429) return "Batas reviu tercapai";
  if (err instanceof API.ApiError && (err.status === 502 || err.status === 503)) return "Layanan Pluto sedang tidak tersedia";
  return "Reviu belum berhasil";
}
